/*
 * Conversation preview text derived from current visible post content.
 * Used by the shell's messages menu.
 * Pass the conversation and current user to produce its compact preview.
 * Example: const preview = conversationPreview(conversation, user, context);
 */

export function conversationPreview(conv, user, { document, services }) {
  const message = conv.latest_message;
  if (!message) return 'No messages yet.';

  let body = 'Message removed';
  if (!message.redacted) {
    const raw = message.body || '';
    const scratch = document.createElement('div');
    scratch.innerHTML = services.markdown.renderMarkdown(raw, { reportImages: false });
    scratch.querySelectorAll('img').forEach((img) => img.replaceWith(img.alt || 'Image'));
    body = (scratch.textContent || '').replace(/\s+/g, ' ').trim() || 'Attachment';
  }

  let author = 'System';
  if (message.author_id === user?.id) author = 'You';
  else if (message.author_username) author = `@${message.author_username}`;
  else if (message.author_id) author = 'Unknown user';
  return `${author}: ${body}`;
}
